class PgoSelection {
    constructor({
        sessionStorageKey = 'selectedPgos',
        compareButtonId = 'compare-pgo-btn',
        checkboxSelector = '.pgo-checkbox',
        selectedCountId = 'bar-selected-count',
        hitsContainerId = 'hits',
        maxSelection = 3
    } = {}) {
        this.sessionStorageKey = sessionStorageKey;
        this.compareBtn = document.getElementById(compareButtonId);
        this.checkboxSelector = checkboxSelector;
        this.selectedCount = document.getElementById(selectedCountId);
        this.hitsContainer = document.getElementById(hitsContainerId);
        this.maxSelection = maxSelection;
        this.selectedPgos = JSON.parse(sessionStorage.getItem(this.sessionStorageKey)) || [];
        this.baseUrl = window.location.origin + window.location.pathname;
    }

    init() {
        const container = document.getElementById('pgo-list-container');
        if (!container) return;

        this.restoreSelections();
        this.updateUI();
        this.observeHitsContainer(); 
    }

    saveTosessionStorage() {
        sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this.selectedPgos));
    }

    attachCheckboxListeners() {
        const checkboxes = this.hitsContainer.querySelectorAll(this.checkboxSelector);
        if (!checkboxes.length > 0) return;
        
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
        });
    }

    handleCheckboxChange(e) {
        const pgoId = e.target.dataset.id;
        if (e.target.checked) {
            if (this.selectedPgos.length >= this.maxSelection) {
                alert(`Het maximum van ${this.maxSelection} PGO's is bereikt.`);
                e.target.checked = false;
                return;
            }
            this.selectedPgos.push(pgoId);
        } else {
            this.selectedPgos = this.selectedPgos.filter(id => id !== pgoId);
        }

        this.saveTosessionStorage();
        this.updateUI();
    }

    restoreSelections() {
        this.selectedPgos.forEach(pgoId => {
            const checkbox = this.hitsContainer.querySelector(`${this.checkboxSelector}[data-id="${pgoId}"]`);
            if (checkbox) checkbox.checked = true;
        });
    }

    updateUI() {
        const params = new URLSearchParams(window.location.search);
        let medMijParam = params.get('verbindmedmij');
        medMijParam = medMijParam ? '&verbindmedmij=' + medMijParam : '';

        
        if (this.selectedCount) {
            this.selectedCount.textContent = this.selectedPgos.length;
            if (this.compareBtn) this.compareBtn.textContent = `Vergelijk PGO's (${this.selectedPgos.length})`;
        }

        if (this.compareBtn) {
            const query = this.selectedPgos.join(',');
            this.compareBtn.href = query ? `${this.baseUrl}/vergelijken?pgo=${query}${medMijParam}` : this.baseUrl;
        }
    }

    // observe the Algolia container for any changes
    observeHitsContainer() {
        if (!this.hitsContainer) {
            console.error('Hits container not found!');
            return;
        }

        const observer = new MutationObserver(() => {
            this.attachCheckboxListeners();
            this.restoreSelections();
        });

        observer.observe(this.hitsContainer, { childList: true, subtree: true });
    }
}

export default PgoSelection;
